import React, { useState, useEffect, useMemo, useRef } from 'react';
import axios from 'axios';
import DashboardLayout from '../Dashboard/layout';
import Swal from 'sweetalert2';
import JoditEditor from 'jodit-react';
import "./TermsEditor.css"
import { Headings } from '../RegisteredUsersList/ViewRegList';

const TermsEditor = () => {
  const editor = useRef(null);
  const [condition, setCondition] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}api/admin/terms`)  
      .then((response) => {
        // Check if terms content exists or not
        if (response.data.terms && response.data.terms.content) {
          setCondition(response.data.terms.content);  // Load existing terms
        } else {
          setCondition(''); // No terms yet, user can add them
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching terms:", error);
        const errorMessage = error.response?.data?.message || 'Failed to load terms & conditions.';
        //Swal.fire('Error', errorMessage, 'error');
        setLoading(false);
      });
  }, []); 

  // Handle saving the terms
  const handleSave = async () => {
    if (!condition.trim()) {
      Swal.fire('Error', 'Terms and conditions cannot be empty', 'error');
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/admin/terms`,
        { content: condition }
      );
    
      if (response.status === 200 || response.status === 201) {
        Swal.fire('Success', response.data.message || 'Terms & Conditions saved successfully!', 'success')
          .then(() => {
            window.location.reload();
          });
      } else {
        Swal.fire('Error', 'Something went wrong while saving the terms.', 'error');
      }
    } catch (error) {
      console.error('An error occurred while making the API call:', error);
      Swal.fire('Error', error.response?.data?.message || 'Failed to save terms & conditions.', 'error');
    }
    
  };

  // Editor configuration
  const config = useMemo(() => ({
    readonly: false,
    placeholder: 'Start typing...',
  }), []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;  // Display dynamic error message here
  }

  return (
    <DashboardLayout>
      <section className="MainDivSec">
        <Headings headspan="Terms" hedtext=" & Conditions " />

        <div className="TermEditrDiv">
          <form> 
            <JoditEditor ref={editor}
              value={condition}
              config={config}
              tabIndex={1}
              className="TermsFormsSec"
              onChange={(newContent) => setCondition(newContent)}/>

            <div className="SubMit"><button type="button" onClick={handleSave}> Save </button> </div>
            
          </form>
        </div>
      </section>
    </DashboardLayout>
  );
};

export default TermsEditor;
